module.exports = __webpack_public_path__ + "static/media/auditW.156638c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/auditW.svg
// module id = 554
// module chunks = 0